module.exports = __webpack_public_path__ + "static/img/gt.656c9899.svg";